<template>
	<div id="app">
    <component :is="currentComponent"></component>
	</div>
</template>
<script>
import PC from './views/PC.vue';
import H5 from './views/Home.vue';

export default {
  name: 'App',
  components: {
    PC,
    H5
  },
  data() {
    return {
      currentComponent: null
    };
  },
  mounted() {
    this.rem(750)
    this.detectDevice();
  },
  methods: {
    rem(devwidth){
      function _size() {
        var deviceWidth = window.document.documentElement.clientWidth;
        if (deviceWidth >= devwidth) deviceWidth = devwidth;
        window.document.documentElement.style.fontSize = deviceWidth / (devwidth / 100) + 'px';
      };

      window.onresize=function(){
        _size();
      };

      _size();
    },
    detectDevice() {
      const userAgent = navigator.userAgent;
      // 简单的 PC 和移动设备检测
      if (/Mobi|Android/i.test(userAgent)) {
        this.currentComponent = 'H5';
      } else {
        this.currentComponent = 'PC';
      }
    }
  }
};
</script>

<style>

</style>
